import { GridColumnVisibilityModel, GridFilterModel, GridSortModel } from '@mui/x-data-grid-premium'

export const defaultColumnOrder: string[] = [
  'name',
  'organizations',
  'billingContact',
  'email',
  'phone',
  'timeCreated',
  'source',
  'owner',
]
export const defaultSortModel: GridSortModel = [{ field: 'name', sort: 'asc' }]
export const defaultFilterModel: GridFilterModel = { items: [], quickFilterValues: [] }
export const defaultVisibilityModel: GridColumnVisibilityModel = {
  source: false,
  __tree_data_group__: false,
}
